import React, { useState } from 'react';
import styles from './index.module.scss';

// Components
import { Navbar, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons';
import CustomDropDown from './CustomDropDown';
import ChangePasswordModal from '../ChangePasswordModal';

const Header = (props) => {
    const [showUserMenu, setShowUserMenu] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);

    return (
        <>
            <ChangePasswordModal show={showChangePasswordModal} close={() => setShowChangePasswordModal(false)} />
            <header className={styles.Header}>
                <Navbar bg="dark" variant="dark">
                    <Navbar.Brand href="/" className={styles.Brand}>Servicell Wireless</Navbar.Brand>
                    <Nav className="ml-auto">
                        <Nav.Link href="/" className={styles.Link} style={{ position: 'relative' }} onClick={() => setShowUserMenu(val => !val)}>
                            <span>{props.name} {props.lastname}</span>
                            <FontAwesomeIcon icon={faUser} />
                            <CustomDropDown show={showUserMenu} hide={() => setShowUserMenu(false)}>
                                <CustomDropDown.Item title="Cambiar Contraseña" onClick={() => setShowChangePasswordModal(true)} />
                            </CustomDropDown>
                        </Nav.Link>
                        <Nav.Link href="#logout" className={styles.Link} onClick={props.logoutHandler}>
                            <span>Log Out</span>
                            <FontAwesomeIcon icon={faSignOutAlt} />
                        </Nav.Link>
                    </Nav>
                </Navbar>
            </header>
        </>
    )
};

export default Header;